import { Link } from "react-router-dom";
import styled from "styled-components";
import screenImage from "../../resources/images/a1tcms/screen-classify-basic.jpg";
import SectionHead from "../ui/common/SectionHead";

// 처음 방문한 고객에게 전문성과 신뢰를 보여주는 메인 섹션 (모두 공개된 사실만 사용, 옛 Global Partner 페이지의 Why A-ONE)
const strengths = [
  { no: "01", title: "25년 관세 전문 법인", text: "2001년 창업 이후 수출입통관부터 FTA·AEO·관세심사·행정쟁송까지 관세업무의 시작과 끝을 수행해 왔습니다." },
  { no: "02", title: "AEO AA등급", text: "2010년 AEO 공인, 2013년 AA등급 상향 이후 2018·2023년 재인증을 받았으며, 고객사의 AEO 공인 획득을 지원합니다." },
  { no: "03", title: "23개 FTA 원산지 대응", text: "한국이 발효한 23개 FTA(60개국)의 협정별 원산지 기준과 증명, 사후 검증 대응을 지원합니다." },
  { no: "04", title: "자체 AI 플랫폼", text: "2024년 국내 최초 지능형 HS 품목분류 추천시스템을 개발하고 특허를 출원했으며, ASCP 플랫폼으로 통관·리스크·법률 업무를 연결합니다." },
  { no: "05", title: "공급망·수출통제 대응", text: "美 관세 조치, 수출통제·제재, 강제노동·탄소국경 규제까지 부품 단위로 점검하고 대응 전략을 제시합니다." },
  { no: "06", title: "전국 통관 거점", text: "서울 본사와 부산·인천·평택·울산 지점에서 항만·공항 통관을 직접 수행합니다." },
];

const HomeTrust = () => {
  return (
    <Section>
      <div className="inner">
        <SectionHead title="Why A-ONE" />
        <ul className="facts">
          {strengths.map((s) => (
            <li key={s.no}>
              <span>{s.no}</span>
              <b>{s.title}</b>
              <p>{s.text}</p>
            </li>
          ))}
        </ul>
        <div className="banner">
          <div className="text">
            <div className="eng">AONE Smart Customs Platform</div>
            <div className="title">ASCP · A1 TCMS</div>
            <p>
              품목분류, 관세심사 대비, 전자상거래, 공급망 수출통제까지. 에이원은 자체 플랫폼으로 판단하고, 관세사가 최종 검토합니다.
            </p>
            <div className="links">
              <Link to="/it/ascp" className="primary">ASCP 플랫폼 보기</Link>
            </div>
          </div>
          <figure>
            <div className="window">
              <div className="bar" aria-hidden="true">
                <i />
                <i />
                <i />
              </div>
              <img src={screenImage} alt="A1 TCMS 지능형 품목분류 실제 화면" />
            </div>
            <figcaption>A1 TCMS 지능형 품목분류 실제 화면</figcaption>
          </figure>
        </div>
      </div>
    </Section>
  );
};
export default HomeTrust;

const Section = styled.section`
  background-color: ${({ theme }) => theme.colors.monotone.extralight};
  & > .inner {
    max-width: ${({ theme }) => theme.layout.content};
    margin: 0 auto;
    padding: clamp(3.5rem, 7vw, 6rem) clamp(1.25rem, 4vw, 2.5rem);
    box-sizing: border-box;
  }
  & .facts {
    list-style: none;
    margin: 0 0 2rem;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 1rem;
    @media (max-width: 991px) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    @media (max-width: 575px) {
      grid-template-columns: minmax(0, 1fr);
    }
    & > li {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      padding: 1.6rem 1.5rem;
      border-radius: ${({ theme }) => theme.radius};
      background-color: white;
      box-shadow: ${({ theme }) => theme.shadow.sm};
      border-top: 3px solid ${({ theme }) => theme.colors.accent};
      & > span {
        font-size: 0.85rem;
        font-weight: 800;
        color: ${({ theme }) => theme.colors.accent};
      }
      & > b {
        font-size: 1.25rem;
        font-weight: 800;
        letter-spacing: -0.02em;
        color: ${({ theme }) => theme.colors.dark};
      }
      & > p {
        margin: 0;
        font-size: 0.95rem;
        line-height: 1.7;
        color: ${({ theme }) => theme.colors.monotone.dark};
      }
    }
  }
  & .banner {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.15fr);
    align-items: center;
    gap: 3rem;
    padding: clamp(2rem, 4vw, 3.5rem);
    border-radius: 1.5rem;
    color: white;
    background: radial-gradient(circle at 85% 15%, rgba(1, 101, 172, 0.55), transparent 55%),
      linear-gradient(135deg, ${({ theme }) => theme.colors.ink}, ${({ theme }) => theme.colors.dark});
    overflow: hidden;
    @media (max-width: 991px) {
      grid-template-columns: minmax(0, 1fr);
      gap: 2rem;
    }
    & > .text {
      & > .eng {
        font-size: 0.85rem;
        font-weight: 700;
        letter-spacing: 0.12em;
        text-transform: uppercase;
        color: ${({ theme }) => theme.colors.foreground.highlightinverted};
      }
      & > .title {
        margin: 0.6rem 0 1rem;
        font-size: clamp(2rem, 3.5vw, 2.75rem);
        font-weight: 800;
        letter-spacing: -0.02em;
      }
      & > p {
        margin: 0 0 2rem;
        font-size: 1.05rem;
        line-height: 1.75;
        color: rgba(255, 255, 255, 0.8);
      }
      & > .links {
        display: flex;
        flex-wrap: wrap;
        gap: 0.75rem;
        & > a {
          padding: 0.75rem 1.3rem;
          border-radius: 999px;
          border: 1px solid rgba(255, 255, 255, 0.35);
          font-weight: 600;
          font-size: 0.95rem;
          transition: background-color 0.2s, border-color 0.2s, color 0.2s;
          &:hover {
            border-color: white;
            background-color: rgba(255, 255, 255, 0.1);
          }
          &.primary {
            background-color: white;
            border-color: white;
            color: ${({ theme }) => theme.colors.dark};
            &:hover {
              background-color: ${({ theme }) => theme.colors.accentSoft};
            }
          }
        }
      }
    }
    & > figure {
      margin: 0;
      & > .window {
        border-radius: 0.9rem;
        overflow: hidden;
        background-color: white;
        box-shadow: 0 30px 60px -20px rgba(0, 0, 0, 0.55);
        & > .bar {
          display: flex;
          gap: 0.4rem;
          padding: 0.65rem 0.9rem;
          background-color: ${({ theme }) => theme.colors.monotone.extralight};
          & > i {
            width: 0.6rem;
            height: 0.6rem;
            border-radius: 50%;
            background-color: ${({ theme }) => theme.colors.monotone.light};
          }
        }
        & > img {
          display: block;
          width: 100%;
        }
      }
      & > figcaption {
        font-size: 0.85rem;
        color: rgba(255, 255, 255, 0.6);
        padding-top: 0.75rem;
      }
    }
  }
`;
